import DashboardLayout from '../layouts/DashboardLayout'
// import ContactCreate from '../pages/contact/ContactCreate'
// import ContactList from '../pages/contact/ContactList'
// import ContactDetail from '../pages/contact/ContactDetail'
// import OrderCreate from '../pages/order/OrderCreate'
// import ContactOrderList from '../pages/order/ContactOrderList'
// import ContactHistory from '../pages/contact/ContactHistory'

export const contactMenu = {
  path: '/contact',
  component: DashboardLayout,
  name: 'Contact Source',
  redirect: '/contact-source',
  children: [
    {
      path: '/contact/contact-list/contact-create',
      name: 'ContactCreate',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/ContactCreate.vue'),
      meta: {
        roles: ['contact_create'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách khách hàng',
          to: '/contact/contact-list'
        }, {
          title: 'Tạo khách hàng',
        }]
      },
    },
    {
      path: 'contact-list',
      name: 'ContactList',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/ContactList.vue'),
      meta: {
        roles: ['contact_read', 'contact_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh Sách Khách Hàng',
        }],
        title: 'CRM Dashboard'
      },
    },
    {
      path: '/contact/contact-list/contact-detail/:id',
      name: 'ContactDetail',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/ContactDetail.vue'),
      meta: {
        roles: ['contact_update', 'contact_read', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách khách hàng',
          to: '/contact/contact-list'
        },{
          title: 'Thông Tin Khách Hàng',
        }]
      },
    },
    {
      path: '/contact/contact-list/:id/order-create',
      name: 'OrderCreate',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/OrderCreate.vue'),
      meta: {
        roles: ['order_create'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: '/contact/contact-list/:id/order-list',
      name: 'ContactOrderList',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/ContactOrderList.vue'),
      meta: {
        roles: ['order_read', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách khách hàng',
          to: '/contact/contact-list'
        }, {
          title: 'Lịch sử đơn hàng',
        }]
      },
    },
    {
      path: '/contact/contact-list/:id/contact-history',
      name: 'ContactHistory',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/ContactHistory.vue'),
      meta: {
        roles: ['contact_read', 'contact_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: '/contact/contact-list/:id/vuihoc-account-list',
      name: 'VuihocAccList',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/VuihocAccList.vue'),
      meta: {
        roles: ['contact_read', 'contact_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: '/contact/contact-list/:id/update-contact-info',
      name: 'UpdateContactInfo',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/create-order-new/UpdateContactInfo.vue'),
      meta: {
        roles: ['order_create'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: '/contact/contact-list/:id/create-order-new',
      name: 'CreateOrderNew',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/create-order-new/CreateOrder.vue'),
      meta: {
        roles: ['order_create'],
        requiresAuth: true,
        breadcrumb: [],
        title: 'CRM New Order',
      },
    },
  ],
}

export function getBreadcrumb(to) {
  if(to.name === 'OrderCreate') {
    return [{
      title: 'Danh sách khách hàng',
      to: '/contact/contact-list'
    }, {
      title: 'Thông tin khách hàng',
      to: `/contact/contact-list/contact-detail/${to.params.id}`
    }, {
      title: "Tạo Đơn Hàng"
    }]
  } else if(to.name === 'ContactHistory') {
    return [{
      title: 'Danh sách khách hàng',
      to: '/contact/contact-list'
    }, {
      title: 'Thông tin khách hàng',
      to: `/contact/contact-list/contact-detail/${to.params.id}`
    }, {
      title: "Lịch sử giao dịch"
    }]
  }
}
